import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu";
import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { NavigationMenuItemProps } from "../types";

function NavigationMenuItem({ className, ...props }: NavigationMenuItemProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <NavigationMenuPrimitive.Item
      data-slot="navigation-menu-item"
      className={cn("relative", className, classes)}
      {...native}
    />
  );
}

NavigationMenuItem.displayName = "NavigationMenu.Item";

export default NavigationMenuItem;
